import PageBanner from '../components/PageBanner';
import { SERVICE_IMAGES } from "../components/Images";

const projects = [
  {
    title: 'LMR Shopping Mall',
    year: '2024',
    client: 'LMR Shopping Mall',
    market: 'Commercial',
    image: SERVICE_IMAGES.INDUSTRIAL_CONTROL_PANELS,
    description: 'Complete electrical installation and power distribution system for a modern shopping mall.',
  },
  // Add more projects here
];

const ProjectsPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative pt-32 pb-24 bg-white">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-50" />
        <div className="relative container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-block mb-6">
              <span className="text-blue-600 text-sm font-semibold tracking-wider uppercase">Projects</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Our <span className="text-blue-600">Projects</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Explore our portfolio of successful projects and see how we've helped clients achieve their electrical goals.
            </p>
            <div className="h-1 w-24 bg-blue-600 mx-auto rounded-full"></div>
          </div>
        </div>
      </section>

      <div className="bg-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
            {projects.map((project) => (
              <div
                key={project.title}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <img
                  className="w-full h-80 object-contain"
                  src={project.image}
                  alt={project.title}
                />
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">
                    {project.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {project.description}
                  </p>
                  <div className="mt-4 space-y-2 text-sm text-gray-500">
                    <div>Year Completed: {project.year}</div>
                    <div>Client: {project.client}</div>
                    <div>Market: {project.market}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage; 